export const BRAND = {
  name: 'Still Temple',
  domain: 'stilltemple.com',
  url: 'https://stilltemple.com',
} as const;

// Add only owner-confirmed, created accounts. Never guess a public handle.
export const SOCIAL_CHANNELS: { platform: 'youtube' | 'tiktok' | 'facebook' | 'threads' | 'x'; url: string }[] = [
  // Owner-created 2026-11-04; Claude checked the profile against AGENTS §5/§10.
  { platform: 'youtube', url: 'https://www.youtube.com/@StillTempleHome' },
];
